<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>行動宣言</title-bar>
    <!-- <action-nav /> -->
    <p>
      今は<b>{{ location }}</b>にいます。
    </p>
    <b-form-group label="パーティ結成の合言葉"
      description="現在地にいる他のキャラクターと同じ合言葉を入力すると、パーティを組んで行動します。"
    >
      <b-form-input v-model="form.keyword" />
    </b-form-group>
    <b-form-group id="action" label="現在地でやること">
      <select-list
        :items="quest"
        :fields="[
          { key:'select', label:'', class:'act-select' },
          { key:'type', label:'', filterType:'string', class:'act-type' },
          { key:'action', label:'行動', filterType:'string', class:'act-action' },
          { key:'detail', label:'詳細', filterType:'string', class:'act-detail' }
        ]"
        :perPage="5"
        tableKey='value'
        :selectable="true"
        tableClass='action-list'
      >
        <template v-slot:cell(select)="row">
          <b-form-radio name="action"
            v-model="form.action"
            :value="row.item.value"
            class="area"
          >
          </b-form-radio>
        </template>
        <template v-slot:cell(type)="row">
          <div v-if="!row.item.expire">★</div>
          <div v-else></div>
        </template>
        <template v-slot:cell(action)="row">
          <div v-html="row.item.action"></div>
        </template>
        <template v-slot:cell(detail)="row">
          <div v-html="row.item.detail"></div>
        </template>
      </select-list>
    </b-form-group>
    <component :is="selectedQuest.type"
      :option="form.subAction" @input="form.subAction = $event"
    />
    <b-form-group id="card" label="カード選択">
      <card-list v-model="form.selectCard"
        :list="cardList" :master="cardMaster" select
        @remove="removeEvent"
      >
        <template #default="card">
          <b-form-group v-if="card.index > -1" 
            id="cardPerformance" label="演出">
            <b-form-select v-model="form.event['card'+card.index]" 
              :options="performance" />
          </b-form-group>
        </template>
      </card-list>
    </b-form-group>
    <b-form-group id="shout" label="直前のひとこと">
      <table class="content"><tr>
        <td width="60px">
          <icon-dropdown class="icon" :list="iconList" v-model="form.icon"
            width="60px" height="60px"
          />
        </td>
        <td>
          <remark-editor class="text" v-model="form.shout"
            :danger="200" :warn="100"
          ></remark-editor>
        </td>
      </tr></table>
    </b-form-group>
    <b-form-group id="subAction" label="採集行動">
      <b-tabs 
        content-class="mt-3 sub-action" justified lazy>
        <b-tab title="ステータス" 
          :active="form.collectAction.type == null || form.collectAction.type == 'training'"
          @click="form.collectAction = {type:'training',value:null}">
          <p>
            いずれかのステータスを＋１します。
          </p>
          <b-form-select v-model="form.collectAction.value"
            :options="[
              { value:'STR', text:'STR' },
              { value:'INT', text:'INT' },
              { value:'VIT', text:'VIT' },
              { value:'MND', text:'MND' },
              { value:'DEX', text:'DEX' },
              { value:'AGI', text:'AGI' },
              { value:'HP', text:'HP' },
            ]" 
          />
        </b-tab>
        <b-tab title="カード取得" :active="form.collectAction.type == 'getCard'" 
          @click="form.collectAction = {type:'getCard',value:[]}">
          <p>
            取得したいカードを選択します。複数選んだ場合はどれか一枚をランダムに取得します。
          </p>
          <card-list v-if="form.collectAction.type == 'getCard'"
            v-model="form.collectAction.value"
            :list="collectionList" :master="cardMaster" select
            />
        </b-tab>
        <b-tab title="カード合成" :active="form.collectAction.type == 'mixCard'" 
          @click="form.collectAction = {type:'mixCard',value:[]}">
          <p>
            １枚目に選択したカードに、２枚目以降のカードを合成します。
          </p>
          <card-list v-if="form.collectAction.type == 'mixCard'"
            v-model="form.collectAction.value"
            :list="cardList" :master="cardMaster" select
            />
        </b-tab>
      </b-tabs>
    </b-form-group>
    <b-form-group id="destination" label="移動">
      <b-alert variant="warning" :show="emergencyEscape">
        緊急脱出が選択されています！この移動先は無視されます。
      </b-alert>
      <b-form-radio name="destination" v-for="val in fields" :key="val.rid"
        v-model="form.destination"
        :value="val.rid"
        :disabled="emergencyEscape"
      >
        {{ val.name }}
        <span v-if="val.spot === 2">(異世界)</span>
        <span v-else-if="val.spot">(スポット)</span>
      </b-form-radio>
    </b-form-group>
    <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
    <response-message :value="postMessage" />
    <pagenate>
      <template #next>
        <router-link to="/makeevent">イベント作成</router-link>
        <b-icon icon="chevron-right" />
      </template>
    </pagenate>
  </WhitePage>
</template>

<script>
import phina from 'phina.js'
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import RemarkEditor from '@/components/RemarkEditor'
import IconDropdown from '@/components/IconDropdown'
// import ActionNav from '@/components/ActionNav'
import ResponseMessage from '@/components/ResponseMessage'
import SelectList from '@/components/SelectList'
import _ from 'lodash'
import parts from './mixin-parts'
import Pagenate from '@/components/Pagenate'
import CardList from '@/components/CardList'
export default {
  components: {
    WhitePage,
    TitleBar,
    RemarkEditor,
    IconDropdown,
    // ActionNav,
    ResponseMessage,
    SelectList,
    Pagenate,
    CardList
  },
  computed: {
    selectedQuest () {
      if(this.form.action){
        return _.find(this.quest, { value:this.form.action })
      }else{
        return { type:'none' }
      }
    },
    performance () {
      return _.map(_.keys(this.form.performance), 
        k=>{ return { value:k, text:this.form.performance[k].name } })
    }
  },
  data () {
    return {
      loading: false,
      quest: [],
      destination: '',
      location: '',
      iconList: [],
      fields: {},
      form: {
        action: null,
        icon: null,
        shout: '',
        destination: null,
        keyword: '',
        subAction: {},
        collectAction: {type:'training',value:null},
        selectCard: [],
        event: {},
        performance: {},
      },
      emergencyEscape: false,
      cardList: [],
      collectionList: [],
      cardMaster: {},
      postMessage: {},
    }
  },
  mixins: [
    CheckLogin,
    parts
  ],
  methods: {
    setData (response) {
      this.form.action = response.action
      this.form.shout = response.shout
      this.form.icon = response.icon
      this.form.destination = response.destination
      this.form.keyword = response.keyword
      this.form.subAction = response.subAction
      this.form.collectAction = response.collectAction
      this.form.selectCard = response.selectCard
      this.form.performance = response.performance
      this.form.event = response.event
      this.fields = response.fields
      this.location = response.location
      this.iconList = response.iconList
      this.quest = response.quest
      this.emergencyEscape = !!response.emergencyEscape
      this.cardList = response.cardList
      this.collectionList = response.collectionList
      this.cardMaster = response.cardMaster
    },
    onSubmit () {
      this.$store.dispatch('setMove', this.form)
        .then((response) => {
          this.postMessage = response
        })
    },
    removeEvent (i) {
      this.$delete(this.form.event, 'card'+i)
      // 左にずらす
      for(let j = i; j < 5; j++){
        if(this.form.event['card'+j+1]){
          this.form.event['card'+j] = this.form.event['card'+j+1]
        }else{
          this.$delete(this.form.event, 'card'+j)
        }
      }
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getMove')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
  },
  mounted () {
    phina.global.app.currentScene.exit('MainScene')
  }
}
</script>

<style lang="scss" scoped>
.eno {
  position: relative;
  top: 20px;
  font-size: medium;
}
.action {
  margin: 3px;
}
#subAction {
  ::v-deep .sub-action {
    padding: 10px;
    border: 1px solid #CCC;
  }
}
#shout {
  .content {
    width: 100%;
  }
}
#action {
  // overflow-x: scroll;

  ::v-deep .action-list {
    width: 920px;
  }
  ::v-deep .act-select,
  ::v-deep .act-type {
    width: 40px;
  }
  ::v-deep .act-action {
    width: 300px;
  }
  ::v-deep .act-detail {
    width: 580px;
  }
}
</style>
